import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";

const TrialExpiredModal = ({
  open,
  onRenew,
  onCancel,
  onActivatePlan,
  onCancelSubscription,
  cancelLoading = false,
}) => {
  const handleActivatePlan = () => {
    const activateHandler = onActivatePlan ?? onRenew;
    if (activateHandler) {
      activateHandler();
      return;
    }
    toast.error("Payment page URL is not configured. Please contact your administrator.");
  };

  const handleCancelSubscription = () => {
    const cancelHandler = onCancelSubscription ?? onCancel;
    if (cancelHandler) {
      cancelHandler();
    }
  };

  return (
    <Dialog
      open={open}
      disableEscapeKeyDown
      onClose={(_, reason) => {
        if (reason === "backdropClick") return;
      }}
      aria-labelledby="trial-expired-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle id="trial-expired-title" sx={{ fontWeight: 600 }}>
        Free Trial Expired
      </DialogTitle>
      <DialogContent>
        <p style={{ margin: "0 0 12px", lineHeight: 1.6, color: "#333" }}>
          Your 30-day free trial has expired.
        </p>
        <p style={{ margin: 0, lineHeight: 1.6, color: "#333" }}>
          To continue accessing the platform and all of its features, please activate a paid
          subscription. If you do not wish to continue, you may cancel your subscription request
          below.
        </p>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={handleCancelSubscription}
          disabled={cancelLoading}
          sx={{ textTransform: "none", minWidth: 140 }}
        >
          {cancelLoading ? (
            <>
              <CircularProgress size={18} sx={{ mr: 1 }} />
              Cancelling...
            </>
          ) : (
            "Cancel Subscription"
          )}
        </Button>
        <Button
          variant="contained"
          onClick={handleActivatePlan}
          disabled={cancelLoading}
          sx={{
            textTransform: "none",
            minWidth: 120,
            backgroundColor: "#2c68a1",
            "&:hover": { backgroundColor: "#245a8c" },
          }}
        >
          Activate Plan
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TrialExpiredModal;
